'use client'

import { useAuth } from "@/context/AuthContext"

export default function Favourite({ gameId }: Readonly<{gameId: string}>){
    const { user } = useAuth()

    function handleFavourite(){
        // TODO: capire come gestire senza ricaricare la pagina
        if (user?.preferedGames === null || user?.preferedGames?.some(item => item.id == gameId) == false) {
            fetch(`/api/addFavourite?uid=${user.uid}&gameId=${gameId}`).then(() => {
                alert("Aggiunto ai preferiti")
                window.location.reload()
            })
        } else if (user?.preferedGames != null && user?.preferedGames?.some(item => item.id == gameId) == true) {
            fetch(`/api/removeFavourite?uid=${user.uid}&gameId=${gameId}`).then(() => {
                alert("Rimosso dai preferiti")
                window.location.reload()
            })
        }
    }

    return(
        <>
            { user != null &&
                <button onClick={handleFavourite}>
                    <i className={`${(user.preferedGames != null && user?.preferedGames?.some(item => item.id == gameId)) ? 'bi-star-fill text-yellow-300' : 'bi-star'} text-2xl`} />
                </button>
            }
        </>
    )
}